import React from 'react';

const Footer = () => (
    <footer className="main-footer" style={styles}>
        <div className="container">
            <div className="pull-right hidden-xs">
            </div>
            {/* <strong>Copyright © 2014-2020 <a href="https://www.vtcall.com.br/" target="_blank" rel="noopener noreferrer" >VTCALL</a>.</strong> Todos direitos reservados. */}
        </div>
    </footer>
);

const styles = {
    bottom: '0',
    // position: 'fixed',
    right: 0,
    left: 0,
    // zIndex: 1030,
};

export default Footer;


